module.exports = __webpack_public_path__ + "static/media/icon.28656f1c.png";